import { render } from "./AppNewsletter.vue?vue&type=template&id=27514f15"
import script from "./AppNewsletter.vue?vue&type=script&lang=js"
export * from "./AppNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/majstro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__